import Popper from '@popperjs/core';
import * as bootstrap from 'bootstrap'

// Import Bootstrap SCSS for general styles
import '../../scss/bootstrap-grid.scss';
import '../../scss/bootstrap-reboot.scss';
import '../../scss/bootstrap-utilities.scss';

window.bootstrap = bootstrap;
